export default __webpack_public_path__ + "91bacab1f083f2795272499faf7e83dc.ttf";